// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2A2FB","assignButton":"CreateEditEquipmentSchedule_assignButton__1MepA"};